import { withTheme } from 'styled-components';
import JourneySegment from './JourneySegment';

export default withTheme(JourneySegment);
